import {CARD_TYPE} from "@/constant/Constant";
import useSettings from "@/hook/useSettings";
import {useEffect, useState} from "react";
import "swiper/css";
import "./index.less";

export default function CardImage({cardType, height}) {
  const [img, setImg] = useState();
  const {
    settings
  } = useSettings();

  useEffect(() => {
    if (cardType) {
      const fileName = cardType == CARD_TYPE.CARD_TYPE_PHYSICAL ? 'physical' : 'virtual';
      const isDark = settings.theme == 'dark';
      // setImg(`/images/cards/card-${fileName}-${isDark ? 'dark' : 'light'}.png`);
      setImg(`/images/sonic/sonic-card-mini.png`);
    }
  }, [cardType]);

  if (!img) return null;

  return (
    <img style={{borderRadius:"4px"}} src={img} height={height}/>
  );
}
